import { render, staticRenderFns } from "./ConfigurationRuleCard.vue?vue&type=template&id=0f1c4c06&scoped=true&"
import script from "./ConfigurationRuleCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationRuleCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationRuleCard.vue?vue&type=style&index=0&id=0f1c4c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c4c06",
  null
  
)

export default component.exports